import { Injectable } from '@angular/core';
import { Font } from '@core/models';
import { FontsService } from '@core/services/fonts.service';
import { BehaviorSubject } from 'rxjs';

export interface FontParameters {
  fontFamily?: string;
  fontSize?: number;
  fontWeight?: 100 | 200 | 300 | 400 | 500 | 600 | 700 | 800 | 900;
}

@Injectable({
  providedIn: 'root',
})
/** @deprecated */
export class FontParametersService {
  private _fontSize: number | null = null;

  public get fontSize(): number | null {
    return this._fontSize;
  }

  public set fontSize(value: number | null) {
    this._fontSize = value;
    if (value === null || value === undefined) {
      sessionStorage.removeItem('fontSize');
    } else {
      sessionStorage.setItem('fontSize', JSON.stringify(value));
    }
  }

  private _fontWeight: 100 | 200 | 300 | 400 | 500 | 600 | 700 | 800 | 900 | null = null;

  public get fontWeight(): 100 | 200 | 300 | 400 | 500 | 600 | 700 | 800 | 900 | null {
    return this._fontWeight;
  }

  public set fontWeight(value: 100 | 200 | 300 | 400 | 500 | 600 | 700 | 800 | 900 | null) {
    this._fontWeight = value;
    if (value === null || value === undefined) {
      sessionStorage.removeItem('fontWeight');
    } else {
      sessionStorage.setItem('fontWeight', JSON.stringify(value));
    }
  }

  private _fontFamily: string | null = null;

  public get fontFamily(): string | null {
    return this._fontFamily;
  }

  public set fontFamily(value: string | null) {
    this._fontFamily = value;
    if (value === null || value === undefined) {
      sessionStorage.removeItem('fontFamily');
    } else {
      sessionStorage.setItem('fontFamily', JSON.stringify(value));
    }
  }

  public readonly fonts: Font[] = [];

  public readonly fontsLoaded = new BehaviorSubject<boolean>(false);

  public fontParameters: {
    group: FontParameters;
    players: {
      parameters: FontParameters;
    }
  };

  constructor(private _fontsService: FontsService) {
    this._fontsService.getFonts(['speedreading']).subscribe((res) => {
      this.fonts.push(...res);
      this.fontsLoaded.next(true);
    });

    const fontParameters = sessionStorage.getItem('font-parameters');

    const fontWeightRaw = sessionStorage.getItem('fontWeight');
    if (fontWeightRaw !== null && fontWeightRaw !== undefined) {
      this.fontWeight = JSON.parse(fontWeightRaw);
    }

    const fontFamilyRaw = sessionStorage.getItem('fontFamily');
    if (fontFamilyRaw !== null && fontFamilyRaw !== undefined) {
      this.fontFamily = JSON.parse(fontFamilyRaw);
    }
  }
}
